declare const require: {
  context: (
    directory: string,
    useSubdirectories: boolean,
    regExp: RegExp
  ) => {
    keys: () => string[];
    (id: string): unknown;
  };
};

// Context is rebuilt whenever this module changes so new entity shards are
// picked up without restarting the playground.

export const importEntityShardModule = async (
  entityType: string,
  token: string
): Promise<unknown> => {
  return import(`./entity_db/${entityType}/${token}`);
};

export const requireEntityShardModule = (
  entityType: string,
  token: string
): unknown => {
  const dbContext = require.context(
    "./entity_db",
    true,
    /^\.\/[^/]+\/[^/]+\.ts$/
  );
  return dbContext(`./${entityType}/${token}.ts`);
};

export const listEntityShardKeys = (): string[] => {
  const dbContext = require.context(
    "./entity_db",
    true,
    /^\.\/[^/]+\/[^/]+\.ts$/
  );
  return dbContext.keys();
};
